import styles from './index.module.css';
import LogoImg from '../../assets/images/brand/test.png';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { faFacebook, faInstagram, faLinkedin, faSquareWhatsapp, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleNavigation = (e, path) => {
        if (path.startsWith("#")) {
            e.preventDefault();

            const sectionId = path.replace("#", "");
            const element = document.getElementById(sectionId);
            if (location.pathname === "/") {
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            } else {
                navigate(`/${path}`);
            }
        }
        else if (path === "/" && location.pathname === "/") {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <>
            <div className={`main-container ${styles.footerContainerBottom}`}>
                <div className={`container-content ${styles.footer}`}>
                    <div className={styles.bottomFooter}>
                        <div className={styles.bottomFooterUpper}>
                            <div className={styles.logoSec}>
                                <Link to="/">
                                    <img src={LogoImg} alt="Logo" className={styles.logoImg} />
                                </Link>
                                <div className={styles.socialMedia}>
                                    <a href="https://web.facebook.com/profile.php?id=61584655946235" target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF' }}>
                                        <FontAwesomeIcon icon={faFacebook} className={styles.socialIcon} />
                                    </a>
                                    <a href="https://www.tiktok.com/@studyhubplus" target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF' }}>
                                        <FontAwesomeIcon icon={faTiktok} className={styles.socialIcon} />
                                    </a>
                                    <a href="https://www.youtube.com/@studyhub-b7o" target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF' }}>
                                        <FontAwesomeIcon icon={faYoutube} className={styles.socialIcon} />
                                    </a>
                                </div>
                            </div>
                            <div className={styles.listSec}>
                                <ul className={styles.navList}>
                                    <li> <Link to="#about" className={`${styles.footerLink}`} onClick={(e) => handleNavigation(e, '#about')}>About Us</Link></li>
                                    <li> <Link to="#contact" className={`${styles.footerLink}`} onClick={(e) => handleNavigation(e, '#contact')}>Contact Us</Link></li>
                                </ul>
                                <ul className={styles.navList}>
                                    <li> <Link to="/privacy-policy" className={`${styles.footerLink}`}>Privacy Policy</Link></li>
                                    <li> <Link to="/terms-and-conditions" className={`${styles.footerLink}`}>Terms and Conditions</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.bottomFooterLower}>
                Copyright © {new Date().getFullYear()}{" "}
                <a href="https://www.ardillalabs.com" target="_blank" rel="noopener noreferrer" style={{ color: '#1d0c50' }}>Ardillalabs</a> Pvt Ltd. All rights reserved
            </div>
        </>
    )
}

export default Footer;